<template>
  <div class="bg">
    <div class="cant"><img src="../../../static/images/cant.png"></div>
    <div class="round1"><img src="../../../static/images/round1.png"></div>
    <div class="round2"><img src="../../../static/images/round2.png"></div>

    <section class="login-box">
      <div class="from-box" :style="{'marginTop':boxTop+'px'}">

        <div class="from-box-row from-box-left">
          <div class="from-main-box">
            <div class="from-main-logo"><img src="../../../static/images/logo.png"></div>
            <div class="from-main-hint">24小时在线 实惠高效 丢件赔付 服务保障</div>
            <div class="from-main">
              <ul>
                <li class="from-main-input"><input type="text" v-on:keydown.13="login" v-model="username" placeholder="请输入手机号" /></li>
                <li class="VerificationCode from-main-input" v-if="!isLogin">
                  <input maxlength="6" type="tel" required v-model="code" placeholder="请输入验证码" />
                  <div class="VerificationCodeBtn NoSelect" v-on:click="get_code" v-if="CodeTime <= 1">获取验证码</div>
                  <div class="VerificationCodeBtn NoSelect" style="background-color: #CCC;" v-text="CodeTime+'s'"
                    v-else></div>
                </li>
                <li class="from-main-input">
                  <input type="password" v-if="isLogin" v-on:keydown.13="login" v-model="password" placeholder="密码" />
                  <input type="password" v-else v-on:keydown.13="submitFrom" v-model="password" placeholder="密码" />
                </li>
                <li v-if="!isLogin" class="from-main-input"><input type="password" v-on:keydown.13="submitFrom" v-model="repassword"
                    placeholder="重复输入密码" /></li>
                <li class="from-main-btn" v-if="isLogin">
                  <a v-on:click="login">登录</a>
                </li>
                <li class="from-main-btnTwo" v-else>
                  <a v-on:click="submitFrom">确定</a>
                  <a v-on:click="drawer">取消</a>
                </li>

                <li class="from-main-btnarr" v-if="isLogin">
                  <a v-on:click="drawer(2)">忘记密码？</a>
                  <a href="https://heiling.yeeke.com/duiguo/user/register?flag=YUSCL" target="_blank">新用户注册</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="from-box-row from-box-right">
          <img class="from-box-img" src="../../../static/images/bg.png">
        </div>

      </div>
    </section>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>


  </div>
</template>

<script>
  var self;
  import axios from 'axios'
  axios.defaults.withCredentials = true;
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Login',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        boxTop: 150,
        boxType: 1,
        username: null,
        password: null,
        repassword: null,
        isLogin: true,
        code: null,
        CodeTime: 1,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        pcode: null,
        url:null
      }
    },
    mounted() {
      self = this;

      //返利代码
      var url = window.location.href;
      var fix = url.indexOf("=");
      var lix = url.indexOf("#")
      if(fix > 0){
        var pcode = url.substring(fix+1,lix);
        self.pcode = pcode;
      }
      self.url = url;
      if (self.$route.query.id) {
        self.pcode = self.$route.query.id;
      }

      if (document.documentElement.clientHeight > 600) {
        this.boxTop = (document.documentElement.clientHeight - 590) / 2;
      }

      //店铺授权返回
      if (self.GetUrlPar("shop_id")) {
        if(localStorage.getItem("ExShopee_Sort") == "上架"){
          window.location.href = "http://seller.exshopee.cn/#/Shops?shop_id=" + self.GetUrlPar("shop_id") + "&code=" + self.GetUrlPar("code")
        }else{
          window.location.href = "http://seller.exshopee.cn/#/Shop?shop_id=" + self.GetUrlPar("shop_id") + "&code=" + self.GetUrlPar("code")
        }
      }

      //店铺授权返回
      if (self.GetUrlPar("main_account_id")) {
        if(localStorage.getItem("ExShopee_Sort") == "上架"){
          window.location.href = "http://seller.exshopee.cn/#/Shops?main_account_id=" + self.GetUrlPar("main_account_id") +
            "&code=" + self.GetUrlPar("code")
        }else{
          window.location.href = "http://seller.exshopee.cn/#/Shop?main_account_id=" + self.GetUrlPar("main_account_id") +
            "&code=" + self.GetUrlPar("code")
        }
      }

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      drawer(te) {
        if (self.isLogin) {

          self.boxType = te;
          self.isLogin = false;
          self.password = null;
          self.repassword = null;
          self.code = null;
        } else {

          self.isLogin = true;
          self.password = null;
        }
      },
      get_code() {
        if (!self.username) {
          self.ToastFun(2, "手机号码不能为空！"); //弹窗提醒
          return;
        }
        self.loading = true;
        let param = new URLSearchParams()
        param.append('boxType', self.boxType)
        param.append('username', self.username)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/send_sms/",
          data: param
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var res = JSON.parse(datas);
            if (res.Code == "OK") {
              self.CodeTime = 60;
              let timer = setInterval(function() {
                self.CodeTime--;
                if (self.CodeTime <= 1) {
                  clearInterval(timer);
                }
              }, 1000)
              self.ToastFun(0, "发送成功，请注意查收！"); //弹窗提醒
            }
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      submitFrom() {
        let param = new URLSearchParams()
        if (self.pcode) {
          param.append('pcode', self.pcode)
        }
        param.append('boxType', self.boxType)
        param.append('username', self.username)
        param.append('code', self.code)
        param.append('password', self.password)
        param.append('repassword', self.repassword)
        if (!self.username || !self.code || !self.password || !self.repassword) {
          self.ToastFun(2, "必填项不能为空！"); //弹窗提醒
          return;
        }
        if (self.password != self.repassword) {
          self.ToastFun(2, "两次密码不一致！"); //弹窗提醒
          return;
        }
        var _url = "/user_reg/";
        if (self.boxType == 2) {
          _url = "/chang_pwd/";
        }
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + _url,
          data: param
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.Confirm.style = 1;
            self.Confirm.state = true;
            if (self.boxType == 1) {
              self.Confirm.txt = "注册成功，是否前往登录？"
            } else {
              self.Confirm.txt = "修改成功，是否前往登录？"
            }
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      login() {
        let param = new URLSearchParams()
        param.append('username', self.username)
        param.append('password', self.password)
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/login/",
          data: param
        }).then(function(response) {
          self.loading = false;
          var json = response.data;
          if (json.code == 200) {
            var datas = json.datas;
            localStorage.removeItem("ExShopee_NavSubIx");
            localStorage.setItem("ExShopee_Role", datas.role); //左侧导航焦点样式
            localStorage.setItem("ExShopee_UserName", self.username);
            localStorage.setItem("ExShopee_NickName", datas.nickname);
            localStorage.setItem("ExShopee_token", datas.token);
            localStorage.setItem("ExShopee_id", datas.id);
            localStorage.setItem("ExShopee_isrebate", datas.is_distribution);
            if (datas.role == 10) {
              if(localStorage.getItem("ExShopee_Sort") == "上架"){
                localStorage.setItem("ExShopee_HistoryURL", "AdminProHome"); //左侧导航焦点样式
                self.GoToPage('/AdminProHome'); // 路由跳转
              }else{
                localStorage.setItem("ExShopee_HistoryURL", "AdminHome"); //左侧导航焦点样式
                self.GoToPage('/AdminHome'); // 路由跳转
              }
            } else if (datas.role == 20) {
              localStorage.setItem("ExShopee_HistoryURL", "DeHome"); //左侧导航焦点样式
              self.GoToPage('/DeHome'); // 路由跳转
            } else {

              if(localStorage.getItem("ExShopee_Sort") == "上架"){
                localStorage.setItem("ExShopee_HistoryURL", "HomePage"); //左侧导航焦点样式
                self.GoToPage('/HomePage'); // 路由跳转
              }else{
                localStorage.setItem("ExShopee_HistoryURL", "UserHomePage"); //左侧导航焦点样式
                self.GoToPage('/UserHomePage'); // 路由跳转
              }

            }
          } else {
            self.ToastFun(2, json.msg); //弹窗提醒
            $(".from-box").removeClass('shake_effect');
            setTimeout(function() {
              $(".from-box").addClass('shake_effect')
            }, 1);
          }
        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          console.log(data.state)
          self.Confirm.state = false;
          self.isLogin = true;
        }
      },
      GetUrlPar(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return (false);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-box {
    position: fixed;
    top:0;left:0;
    height: 100%;
    width: 100%;
    overflow: auto;
  }

  .cant {
    position: fixed;
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
  }

  .cant img {
    height: 100%;
    display: block;
  }

  .round1 {
    position: fixed;
    top: 0;
    left: 0;
    width: 250px;
  }

  .round1 img {
    display: block;
    width: 100%;
  }

  .round2 {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
  }

  .round2 img {
    position: absolute;
    right: 0;
    top: 30%;
    display: block;
    height: 40%;
  }

  .from-box {
    position: relative;
    width: 1200px;
    margin: 50px auto;
    height: 590px;
    background-color: #FFF;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  }

  .from-box-row {
    float: left;
  }

  .from-box-left {
    width: 45%;
  }

  .from-box-right {
    width: 55%;
    position: relative;
  }

  .from-box-img {
    width: 780px;
    height: 685px;
    display: block;
    position: absolute;
    top: -95px;
    right: 0;
  }

  .from-main-box {
    width: 350px;
    margin: 0 auto;
  }

  .from-main-logo {
    width: 220px;
    margin-top: 80px;
  }

  .from-main-logo img {
    display: block;
    width: 100%;
  }

  .from-main-hint {
    margin: 20px 0;
    font-size: 16px;
    color: #666;
    margin-bottom: 30px;
  }

  .from-main-input {
    margin-top: 25px;
  }

  .from-main-input input {
    border: 0;
    font-size: 16px;
    height: 50px;
    width: calc(100% - 20px);
    padding: 0 10px;
    border-bottom: 1px solid #EEE;
  }

  .from-main-btn a {
    color: #FFF;
    display: block;
    margin: 0 auto;
    text-align: center;
    padding: 15px 0;
    font-size: 17px;
    border-radius: 100px;
    margin-top: 40px;
    background-color: #2860eb;
    cursor: pointer;
  }

  .from-main-btn a:hover {
    opacity: 0.9;
  }

  .from-main-btnarr {
    overflow: hidden;
    padding: 0 20px;
    margin-top: 15px;
    font-size: 15px;
  }

  .from-main-btnarr a {
    cursor: pointer;
  }

  .from-main-btnarr a:last-child {
    float: right;
    color: #007DDB;
  }

  .from-main-btnarr a:hover {
    opacity: 0.95;
  }

  .from-main-btnTwo {
    overflow: hidden;
  }

  .from-main-btnTwo a {
    float: left;
    width: 48%;
    color: #FFF;
    display: block;
    text-align: center;
    padding: 15px 0;
    font-size: 17px;
    border-radius: 10px;
    margin-top: 40px;
    cursor: pointer;
  }

  .from-main-btnTwo a:hover {
    opacity: 0.95;
  }

  .from-main-btnTwo a:first-child {
    background-color: #2860eb;
  }

  .from-main-btnTwo a:last-child {
    color: #FFF;
    margin-left: 4%;
    background-color: #ccc;
  }

  .VerificationCode {
    position: relative;
  }

  .VerificationCodeInput {
    float: left;
    width: calc(100% - 100px) !important;
  }

  .VerificationCodeBtn {
    position: absolute;
    width: 100px;
    top: 0;
    right: 0;
    height: 50px;
    font-size: 14px;
    text-align: center;
    color: #FFF;
    cursor: pointer;
    line-height: 50px;
    background-color: #4ca4fe;
  }

  .VerificationCodeBtn:hover {
    opacity: 0.9;
  }

  .shake_effect {
    -webkit-animation-name: shake;
    animation-name: shake;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
  }

  @-webkit-keyframes shake {

    from,
    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
      -webkit-transform: translate3d(-10px, 0, 0);
      transform: translate3d(-10px, 0, 0);
    }

    20%,
    40%,
    60%,
    80% {
      -webkit-transform: translate3d(10px, 0, 0);
      transform: translate3d(10px, 0, 0);
    }
  }

  @keyframes shake {

    from,
    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
      -webkit-transform: translate3d(-10px, 0, 0);
      transform: translate3d(-10px, 0, 0);
    }

    20%,
    40%,
    60%,
    80% {
      -webkit-transform: translate3d(10px, 0, 0);
      transform: translate3d(10px, 0, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Login.vue